import { httpRequest } from "@services/http";
import { JourneyPath } from "@models/journeyPath.model";

export class CommandCreateJourneyPath {
  async run(
    contractId: number,
    pricesheetId: number,
    name: string,
    populationSegmentId: number | null = null,
  ): Promise<JourneyPath> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/journey-paths/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify({ name, population_segment_id: populationSegmentId }),
    });
    return new JourneyPath(response);
  }
}
